import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Card,
    CardBody,
    Container,
} from "reactstrap";

import CommonTable from "../../../components/Common/TableContainer";
import ScheduleAddEditModal from "pages/AllCommonModal/ScheduleAddEditModal/schedule-add-edit-modal";
import TodayAddEditModal from "pages/AllCommonModal/TodayAddEditModal/today-add-edit-modal";
import WrongNumberAddEditModal from "pages/AllCommonModal/WrongNumberAddEditModal/wrong-number-add-edit-modal";
import InprogressAddEditModal from "pages/AllCommonModal/InProgressAddEditModal/in-progress-add-edit-modal";
import FurtherReviewAddEditModal from "pages/AllCommonModal/FurtherReviewAddEditModal/further-review-add-edit-modal";
import FedexReviewAddEditModal from "pages/AllCommonModal/FedexDriverAddEditModal/fedex-driver-add-edit-modal";


const FedexDriver = () => {

    const [searchQuery] = useState("");
    const [fedexDriverAddEditModalOpen, setFedexDriverAddEditModalOpen] = useState(false);
    const columns = [
        { Header: "Apply Date", accessor: "apply_date" },
        { Header: "Name", accessor: "name" },
        { Header: "Phone", accessor: "phone" },
        { Header: "Email", accessor: "email" },
        { Header: "Client", accessor: "client" },
        { Header: "Fedex ID", accessor: "fedex_id" },
        { Header: "Contractor", accessor: "contractor" },
        { Header: "Terminal", accessor: "terminal" },
    ];

    const jobCategoryData = [
        { apply_date: "7:49 AM 10-15-2025", client: "Gulf Coast Parcel, Inc", fedex_id: "8315875", contractor: "KIK transport", terminal: "5115 Dylan Dr, South Bend, IN 46628", name: "Draterrius McCollough", email: "Dmccollough12@gmail.com", candidate: "Rovert Allen",  phone: "(256) 3467 890", date_added: "25-08-2025", post_applied: "", status: "active", last_call_date_time: "15-12-2025",  },
        { apply_date: "7:49 AM 10-15-2025", client: "Szymanski Enterprises Inc.", fedex_id: "5720035", contractor: "Bulldog Transport", terminal: "3200 Rodeo Ct, Bessemer, AL 35022", name: "Ruben Jaime", email: "Jaelinb76@gmail.com", name: "Tony Lockhart", candidate: "Rovert Allen",  phone: "(256) 3467 899", date_added: "12-08-2025", post_applied: "", status: "active", last_call_date_time: "24-12-2025",  },
    ];

    // Filtering only when search button is pressed
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return jobCategoryData;

        return jobCategoryData.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery]);

    const handleEdit = (row) => {
        setFedexDriverAddEditModalOpen(true)
      };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <CommonTable columns={columns} data={filteredData} isActionRequired={false} onEdit={handleEdit}  />
                        </CardBody>
                    </Card>
                    <FedexReviewAddEditModal fedexDriverAddEditModalOpen={fedexDriverAddEditModalOpen} setFedexDriverAddEditModalOpen={setFedexDriverAddEditModalOpen}/>

                </Container>
            </div>
        </React.Fragment>
    );
};

FedexDriver.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(FedexDriver);
